import React from 'react';
import PropTypes from 'prop-types';

const Image = props => <img className="bio-image" src={props.data.profile_image} alt="profile" />;

Image.propTypes = {
	data: PropTypes.object.isRequired,
};

export default Image;



// WEBPACK FOOTER //
// ./wp-content/plugins/core/assets/theme/js/src/divi/people/parts/image.js